import { z } from 'zod';
import { FlowProducedType } from '../../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../../block.js';
import { FlowBlockType } from '../../type.js';
export var FlowOcrDetailLevel;
(function (FlowOcrDetailLevel) {
    FlowOcrDetailLevel["None"] = "none";
    FlowOcrDetailLevel["Page"] = "page";
    FlowOcrDetailLevel["Block"] = "block";
    FlowOcrDetailLevel["Paragraph"] = "paragraph";
    FlowOcrDetailLevel["Word"] = "word";
    FlowOcrDetailLevel["Symbol"] = "symbol";
})(FlowOcrDetailLevel || (FlowOcrDetailLevel = {}));
export var FlowOcrBoundingBoxMode;
(function (FlowOcrBoundingBoxMode) {
    FlowOcrBoundingBoxMode["None"] = "none";
    FlowOcrBoundingBoxMode["All"] = "all";
})(FlowOcrBoundingBoxMode || (FlowOcrBoundingBoxMode = {}));
export var FlowOcrMethod;
(function (FlowOcrMethod) {
    FlowOcrMethod["Legacy"] = "Legacy";
    FlowOcrMethod["VisionLanguageModel"] = "VisionLanguageModel";
})(FlowOcrMethod || (FlowOcrMethod = {}));
export const FlowOcrV2BlockConfigSchema = z.object({
    fileReference: z.string().min(1),
    detailLevel: z.enum(FlowOcrDetailLevel).default(FlowOcrDetailLevel.None),
    boundingBoxMode: z.enum(FlowOcrBoundingBoxMode).default(FlowOcrBoundingBoxMode.None),
    method: z.enum(FlowOcrMethod).default(FlowOcrMethod.Legacy),
    prompt: z.string().optional(),
});
export const FlowOcrV2BlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.OcrV2),
    config: FlowOcrV2BlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.OcrDetailResponse),
});
//# sourceMappingURL=config.js.map